(function() {
  // Only run on Rolex pages
  if (!document.body.classList.contains('product-custom-rolex') &&
      !document.body.classList.contains('template-product-custom-rolex') &&
      !document.body.classList.contains('product-custom-rolex-new') &&
      !document.body.classList.contains('template-product-custom-rolex-new') &&
      !document.body.classList.contains('product-custom-rolex-acc') &&
      !document.body.classList.contains('template-product-custom-rolex-acc')) {
    return;
  }

  function hideEmptyParagraphs() {
    document.querySelectorAll('p').forEach(function(p) {
      var text = p.innerHTML.trim();
      if (
        text === '' ||
        text === '&nbsp;' ||
        text === '\u00a0' ||
        p.textContent.trim() === ''
      ) {
        p.style.display = 'none';
        p.style.margin = '0';
        p.style.padding = '0';
        p.style.height = '0';
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyParagraphs);
  } else {
    hideEmptyParagraphs();
  }

  // Run again after a delay for dynamically rendered content
  setTimeout(hideEmptyParagraphs, 1500);
})();
